import styled from 'styled-components';

export const StyledGrid = styled.div`
  width: 100%;
  display: grid;
  gap: ${({ theme }): string => theme.spacing_unit_x2};
  grid-template-columns: repeat(2, 0.5fr);
`;
